import { signInAnonymously } from "firebase/auth";
import { auth } from "./config";

const STORAGE_KEY = "anonymous_uid";

export const initAnonymousUser = async () => {
  try {

    // ✅ already authenticated
    if (auth.currentUser) {

      localStorage.setItem(
        STORAGE_KEY,
        auth.currentUser.uid
      );

      return auth.currentUser.uid;
    }

    // ✅ sign in anonymously
    const userCredential = await signInAnonymously(auth);

    const uid = userCredential.user.uid;

    localStorage.setItem(STORAGE_KEY, uid);

    console.log("Anonymous UID:", uid);

    return uid;

  } catch (error) {

    console.error("Anonymous login error:", error);
  }
};